import React, { Component } from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet-async';
import { pageTitle } from '../../../util/pageTitles';
import { Button } from 'react-bootstrap';
import { Tooltip, OverlayTrigger } from 'react-bootstrap';

import NoData from '../../../components/NoData/NoData';
import { setChart } from '../../../components/Filter/FilterActions';
import { getData, exportResults } from '../MonteCarloTasksActions';

import Filter from '../../../components/Filter/Filter';
import { DatePicker, Options } from '../../../components/Filter/components';

import MonteCarloTasksChart from './../components/MonteCarloTasksChart';

import { trackTeamDashboardView, trackHowToOpened } from '../../../util/mixpanel';

import exportIcon from '../../../assets/images/download.svg';
import './../MonteCarloTasks.scss';
import ChartDownloadMenu from '../../../components/ChartDownloadMenu';
import ZoomControlButton from '../../../components/ZoomControlButton';

class MonteCarloTasks extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    if (this.props.dashboard && this.props.dashboard._id && this.props.dataIsLoading === false) {
      this.props.setChart('mct');

      trackTeamDashboardView('montecarlotasks');
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.hash != this.props.hash && this.props.dataIsLoading === false) {
      this.handleChange();
    }
  }

  handleChange = force => {
    if (force || !this.props.dataIsLoading) {
      this.props.getData();
    }
  };

  trackHowToMCTasksOpen() {
    trackHowToOpened('montecarlotasks');
  }

  render() {
    const tooltip = (
      <div className="more_info_tooltip">
        <div className="more_info-inner">
          <h4>Monte Carlo: Number of Tasks</h4>
          <p>Simulates task totals between selected dates from past daily throughput. Bars count trials for each total; dashed lines mark totals the selected share of trials reached or exceeded.</p>
          <p><b>Look for:</b> a wide spread of counts, which indicates greater variation among simulated task totals.</p>
          <a
            //href={`https://www.youtube.com/watch?v=U2uYUjZK8f8&list=PLdQ4qpF6dHcJ5KpN51NyCNUb5bS6bbrpC&index=8`}
            href={`https://getnave.com/monte-carlo-number-of-tasks`}
            target="_blank"
            onClick={this.trackHowToMCTasksOpen}
            onAuxClick={this.trackHowToMCTasksOpen}
            className='more_info-link'
            >
              Learn more →
          </a>
        </div>
      </div>
    );

    const totalItems = !this.props.data ? 0 : _.reduce(this.props.data, (p, c) => {
      return p + _.reduce(c.data, (p, c) => p + c.details.length, 0);
    }, 0);

    return (
      <div className="content-wrap">
         <Helmet>
          <title>{pageTitle(`Monte Carlo: Number of Tasks${this.props.dashboard ? ' | ' + this.props.dashboard.name : ''}`)}</title>
        </Helmet>
        <Filter totalItems={totalItems} navigator dateformat enablePercentiles montecarlotasks />
        <div className="chart_box_view">
          <div className="dashboard_head">
            <div className="flex-layout">
              <h1>Monte Carlo: Number of Tasks</h1>
              <div className="more_info_content">
                <span className="more_info"></span>
                {tooltip}
              </div>
            </div>
            <div className="button_tools">
              {this.props.user.config && this.props.user.config.mcdebug && (
                <div className="options">
                  <Button
                    name="export"
                    variant='light-secondary'
                    onClick={() => this.props.dispatch(exportResults(this.props.data))}
                  >
                    <img src={exportIcon} alt="#" />
                  </Button>
                </div>
              )}
              <Options />
              <DatePicker />
            </div>
          </div>
          <div className="diagram_details">
            <ZoomControlButton />
            <ChartDownloadMenu chartId="MonteCarloTasks" />
            <MonteCarloTasksChart id="MonteCarloTasks" data={this.props.data} />
            <NoData show={this.props.noData} loading={this.props.isLoading} />
          </div>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    setChart: name => dispatch(setChart(name)),
    getData: () => dispatch(getData())
  };
};

const mapStateToProps = state => {
  const customFields = _.map(state.filters.allCustomFields, cf => {
    return state.filters.mct[`selected${cf}`];
  });

  return {
    user: state.auth.user,
    hash: state.filters.mct.hash,
    data: state.mct.data,
    noData: state.mct.noData,
    isLoading: state.mct.isLoading,
    dashboard: state.dashboards.selected,
    dataIsLoading: state.app.isLoading,
    customFields
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MonteCarloTasks);
